module.exports = __webpack_public_path__ + "static/media/about-11.aa85eb02.jpg";